import React, { useContext, useEffect, useState } from "react";
import studyReportContext from "../../../../context/studyreport/StudyReportContext";
import ModalHeader from "../../../../components/Modal/ModalHeader";
import { Dropdown, Modal, TextField } from "@fluentui/react";
import ModalFooter from "../../../../components/Modal/ModalFooter";
import QCModalHeader from "../../../../components/Modal/QCModalHeader";
import QCModalFooter from "../../../../components/Modal/QCModalFooter";
import QCFailReasons from "./QCFailReasons";
import ATextField from "../../../../components/ATextField";
import studyviewerContext from "../../../../context/studyviewer/StudyviewerContext";
import { useTranslation } from "react-i18next";
import themeContext from "../../../../context/theme/ThemeContext";
const dropDownStyles = {
  dropdown: {
    width: "200px",
  },
  dropdownItemsWrapper: {
    maxHeight: "300px",
  },
};
const QCReasonModal = (props) => {
  const { getAlterColor, getThemeColor} = useContext(themeContext);
 // const { studyResponseData } = useContext(studyviewerContext);
  const {
    openQcReasonModal,
    setOpenQcReasonModal,
    handleQCReasonClick,
    qcFailReason,
  } = useContext(studyReportContext);
  const [errorMessage, setErrorMessage] = useState("");
  const { t } = useTranslation();

  const handleCancel = () => {
    setOpenQcReasonModal(false);
  };

  const PrimaryButtonList = [
    {
      title: t("QC.ok"),
      onclick: () => {
        handleQCReasonClick();
        setOpenQcReasonModal(false);
      },
    },
  ];

  return (
    <>
      <div
        style={{
          height: "60%",
          width: "60%",
        }}
      >
        {/* <Modal
          isOpen={true}
          titleAriaId="id"
          scrollableContentClassName={"stop-scroll-for-modal"}
        > */}
        <QCModalHeader
          heading={t("QC.qc-return-modal-heading")}
          handleCancel={handleCancel}
        />
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            // backgroundColor: "#000000",
            background: getThemeColor("modal-body"),
            color: getAlterColor("#FFF","#000"),
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
              paddingLeft: "20px",
              paddingTop: "5px",
            }}
          >
            <span
              style={{
                fontWeight: "400",
                fontSize: "12px",
                lineHeight: "16px",
                // color: "rgb(255,255,255,0.8)",
                marginRight: "10px",
              }}
            >
              {props?.patientName}
            </span>
            <span
              style={{
                fontWeight: "400",
                fontSize: "10px",
                lineHeight: "16px",
                // color: "rgb(255,255,255,0.5)",
              }}
            >
              ID {props?.patientId}
            </span>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
              width: "100%",
              padding: "20px",
            }}
          >
            <span
              style={{
                fontSize: "13px",
                // color: "rgb(255,255,255,0.8)",
              }}
            >
              {t("QC.qc-returned-reason-heading")}:{" "}
            </span>
            <span
              style={{
                fontSize: "12px",
                // color: "rgb(255,255,255,0.8)",
              }}
            >
              {qcFailReason}
            </span>
          </div>
        </div>
        <QCModalFooter PrimaryButtonList={PrimaryButtonList} />
        {/* </Modal> */}
      </div>
    </>
  );
};

export default QCReasonModal;
